import { render, staticRenderFns } from "./TheUser.vue?vue&type=template&id=556ded29&scoped=true"
import script from "./TheUser.vue?vue&type=script&lang=js"
export * from "./TheUser.vue?vue&type=script&lang=js"
import style0 from "./TheUser.vue?vue&type=style&index=0&id=556ded29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556ded29",
  null
  
)

export default component.exports